import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from '../components/footer';
import CustomSlide from '../components/ImageGallery/slides';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const PROJECT_QUERY = `*[_type == "project" && slug.current == $slug][0]{
  title,
  "slug": slug.current,
  heroImage,
  galleryImages[],
  donationType,
  donationEmbedId,
  donationEmbedLabel
}`;

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: false,
  responsive: [
    { breakpoint: 5000, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } },
  ],
};

function DonationWidget({ donationType, donationEmbedId, donationEmbedLabel }) {
  useEffect(() => {
    let script;
    if (donationType === 'charitystack') {
      script = document.createElement('script');
      script.src = 'https://prod-donation-elements-b-donationelementsjsfilesb-1m4f4dl6p6b21.s3.us-east-2.amazonaws.com/bundle.js';
      script.async = true;
      document.body.appendChild(script);
    } else if (donationType === 'amanahfy') {
      script = document.createElement('script');
      script.src = 'https://cdn.amanahfy.com/libs/bundle.js';
      script.async = true;
      document.body.appendChild(script);
    }
    return () => {
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [donationType]);

  if (donationType === 'donorbox') {
    return (
      <iframe
        src="https://donorbox.org/embed/donate-to-uhf-1?default_interval=o"
        name="donorbox"
        title="donate"
        style={{ width: '100%', height: '700px', minHeight: '690px', maxHeight: '100vh', backgroundColor: 'white' }}
      />
    );
  }

  if (donationType === 'charitystack' && donationEmbedId) {
    return <div data-entity="EMBED_FORM" data-source="CharityStack" id={donationEmbedId} />;
  }

  if (donationType === 'amanahfy' && donationEmbedId) {
    return (
      <a href={donationEmbedId} id="amanahfy-widget">
        {donationEmbedLabel || 'Donate'}
      </a>
    );
  }

  return null;
}

export default function ProjectDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: project, loading } = useSanityQuery(PROJECT_QUERY, { slug });

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#c8b16f' }}>Loading...</p>
      </div>
    );
  }

  if (!project) {
    navigate('/projects');
    return null;
  }

  const heroImageUrl = project.heroImage
    ? urlFor(project.heroImage).width(1600).url()
    : '/img/projects.jpg';

  const galleryImages = project.galleryImages || [];

  return (
    <div className='wrapperitem'>
      <section className='jumbotron breadcumb' style={{ position: 'relative', overflow: 'hidden', zIndex: 0 }}>
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(3px)',
          zIndex: -2,
        }} />
        <div className='mainbreadcumb' style={{ position: 'relative', zIndex: 1 }}>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>{project.title}</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/">Home</Link>
                  <span className='dash'>/</span>
                  <Link className='link' to="/projects">Projects</Link>
                  <span className='dash'>/</span>
                  <span>{project.title}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid' id="service">
        <div className='row m-10-hor'>
          <div className='col-md-4'>
            <DonationWidget
              donationType={project.donationType}
              donationEmbedId={project.donationEmbedId}
              donationEmbedLabel={project.donationEmbedLabel}
            />
          </div>
          <div className='col-md-8'>
            {galleryImages.length > 0 ? (
              <div className='slickteam'>
                <Slider {...sliderSettings}>
                  {galleryImages.map((image, index) => (
                    <CustomSlide
                      className='itm'
                      index={index}
                      key={index}
                      imgSrc={urlFor(image).width(1200).url()}
                    />
                  ))}
                </Slider>
              </div>
            ) : (
              <div style={{ padding: '40px', textAlign: 'center', color: '#c8b16f' }}>
                Gallery coming soon.
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
